import { Link } from "@tanstack/react-router";
import { ArrowRight, Globe, Search, Wrench } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { webDesignTiers, leadGenTiers } from "@/lib/pricingData";

type Props = { serviceName?: string; startingAt?: string };

type Item = {
  icon: typeof Globe;
  title: string;
  phoneTitle: string;
  price: string;
  period: string;
  phonePeriod: string;
  prefix: string;
  phoneHidden: boolean;
};

const items: Item[] = [
  { icon: Globe, title: "Web Design", phoneTitle: "Web Design", price: webDesignTiers[0].price, period: "one-time", phonePeriod: "", prefix: "From", phoneHidden: false },
  { icon: Search, title: "Monthly Marketing", phoneTitle: "Marketing", price: leadGenTiers[0].price, period: "/ month", phonePeriod: "/mo", prefix: "From", phoneHidden: false },
  { icon: Wrench, title: "Edits & Repairs", phoneTitle: "Edits & Repairs", price: "$250", period: "/ hour", phonePeriod: "/hr", prefix: "", phoneHidden: true },
];

export function PricingTeaserStrip(_props: Props) {
  return (
    <section aria-label="Pricing preview" className="border-y border-border bg-background py-5 lg:py-6">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="grid grid-cols-2 items-center gap-x-5 gap-y-4 sm:grid-cols-3 lg:grid-cols-4">
          {items.map(({ icon: Icon, title, phoneTitle, price, period, phonePeriod, prefix, phoneHidden }) => (
            <div key={title} className={cn("flex items-start gap-3", phoneHidden && "hidden sm:flex")}>
              <Icon className="mt-1 h-5 w-5 shrink-0 text-brand-gold-ink" />
              <div className="min-w-0">
                <p className="truncate text-sm font-semibold text-muted-foreground">
                  <span className="sm:hidden">{phoneTitle}</span>
                  <span className="hidden sm:inline">{title}</span>
                </p>
                <p className="mt-1 whitespace-nowrap text-xl font-bold text-foreground">
                  {prefix && <span className="mr-1 text-sm font-normal">{prefix}</span>}
                  {price}
                  <span className="text-sm font-normal text-muted-foreground">
                    <span className="hidden sm:inline"> {period}</span>
                    <span className="sm:hidden">{phonePeriod}</span>
                  </span>
                </p>
              </div>
            </div>
          ))}
          <div className="col-span-2 flex flex-row gap-3 sm:col-span-3 lg:col-span-1 lg:flex-col">
            <Button asChild className="h-auto flex-1 whitespace-nowrap bg-gradient-gold px-5 py-3 font-bold text-brand-black">
              <Link to="/pricing">Request a Quote<ArrowRight /></Link>
            </Button>
            <Button asChild variant="outline" className="h-auto flex-1 whitespace-nowrap px-5 py-3">
              <Link to="/pricing" hash="add-ons">Build a Plan<Wrench /></Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
